import { InputWithLabel } from '@adotel/components'
import SearchIcon from '@material-ui/icons/Search'

import { getTranslate } from '../../localization'
import useStyles from './styles/PriceClassFilters.styles'

interface PriceClassFiltersProps {
  searchInputValue: string
  setSearchInputValue: React.Dispatch<React.SetStateAction<string>>
  loadingForDisableSearchBox: boolean
}

export default function PriceClassFilters({
  searchInputValue,
  setSearchInputValue,
  loadingForDisableSearchBox
}: PriceClassFiltersProps) {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <InputWithLabel
        placeholder={getTranslate('Search by Price Class name or code')}
        autoComplete="off"
        noHelperText
        fullWidth
        startIcon={<SearchIcon />}
        value={searchInputValue}
        onChange={(event) => setSearchInputValue(event.currentTarget.value)}
        disabled={loadingForDisableSearchBox}
      />
    </div>
  )
}
